import { ExactStringUnionArray } from "helpers";
import { OrganisationPermission } from "store/api/generatedApi.tsx";

export const ORGANISATION_PERMISSION_VALUES = [
  "mission_control_viewer",
  "mission_control_upload",
] as const;

type CheckPermissions = ExactStringUnionArray<
  typeof ORGANISATION_PERMISSION_VALUES,
  OrganisationPermission
>;

true satisfies CheckPermissions;
